export default "__VITE_ASSET__CSXLZnlr__"